import { List } from "@mui/material";
import React from "react";

import { Link, useLocation } from "react-router-dom";

import {
	SidebarListItemButton,
	SidebarListItemText,
	SidebarTitle,
	SidebarWrapper,
} from "./style";
import { SidebarMenuItemValueType } from "./type";

interface ISidebar {
	title: string;
	menuItem: Record<string, SidebarMenuItemValueType>;
}

export default function Sidebar({ title, menuItem }: ISidebar) {
	type MENU_ITEM_KEY_TYPE = [string, SidebarMenuItemValueType];
	const { pathname } = useLocation();

	const pathSplit = pathname.split("/");

	const getListItemButtonSelected = (selectedPath: string): boolean => {
		const selectedSplit = selectedPath.split("/");

		const result = selectedSplit.every((value, index) => {
			if (value[0] === ":") {
				return true;
			}

			if (value === pathSplit[index]) {
				return true;
			}

			return false;
		});

		return result;
	};

	return (
		<SidebarWrapper top={0} width={220}>
			<SidebarTitle>{title}</SidebarTitle>
			<List>
				{Object.entries(menuItem).map(([_, value]: MENU_ITEM_KEY_TYPE) => {
					return (
						<Link
							to={value.path.replace(/:id/, pathname.split("/")[2])}
							key={`list-item-${value.path}`}
						>
							<SidebarListItemButton
								selected={getListItemButtonSelected(
									value.selected || value.path,
								)}
							>
								<SidebarListItemText primary={value.title} />
							</SidebarListItemButton>
						</Link>
					);
				})}
			</List>
		</SidebarWrapper>
	);
}
